import type {
  RechercheQueryDemandeReservationFondsDTO,
  RechercheResultDemandeReservationFondsDTO,
} from '@/features/api/extranet/dto/Demande/Recherche/ReservationFonds'
import { buildRechercheStore } from '../shared'

export const API_PATH_DRF_DEMANDES = '/reservationfonds/demandes'

export const useDRFRechercheDemandeStore = buildRechercheStore<
  RechercheQueryDemandeReservationFondsDTO,
  RechercheResultDemandeReservationFondsDTO
>({
  storeName: 'rechercheDRFDemandeStore',
  apiPath: API_PATH_DRF_DEMANDES,
  location: {
    to: 'recherche',
    domaine: 'drf',
    module: 'demande'
  }
})
